export default __webpack_public_path__ + "static/media/configuracoes.130ca6d1.svg";